module.exports = __webpack_public_path__ + "img/s1.30b21286.png";